<template>
    <div class="mb-1">
        <div class="clearfix">
            <label class="mr-sm-2 pull-left font-weight-bold">Parameter #{{ index + 1 }}</label>
            <a href="#" @click.prevent="delParameter(index)" class="text-danger pull-right" v-b-tooltip.hover title="Delete">
                <font-awesome-icon icon="times-circle" />
            </a>
        </div>
        <div class="form-group">
            <label class="mr-sm-2">Name</label>
            <b-form-input id="name"
                          type="text"
                          class="form-control form-control-sm"
                          v-model="parameters[index].name"
                          @input="getLabel($event)"
                          required
                          placeholder="Name">
            </b-form-input>
        </div>
        <div>
            <label class="mr-sm-2">Label</label>
            <span v-text="parameters[index].label"></span>
        </div>
        <div class="form-group">
            <label class="mr-sm-2">Default Value</label>
            <b-form-input id="value"
                          type="text"
                          class="form-control form-control-sm"
                          v-model="parameters[index].default"
                          required
                          placeholder="Value">
            </b-form-input>
        </div>
        <hr>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "QueryParameter",
        props: ['index'],
        computed: {
            ...mapState('queries', {
                parameters: 'parameters',
            }),
        },
        methods: {
            getLabel(event) {
                this.parameters[this.$props.index].label = ":" + event.replace(/ /g, '_').toLowerCase();
            },
            delParameter(index) {
                this.$store.dispatch('queries/deleteParameter', index);
            },
        }
    }
</script>

<style scoped>
    .form-group {
        margin-bottom: 0.4rem;
    }

    label {
        font-size: 0.7875rem;
        margin-bottom: 0.2rem;
    }

    hr {
        margin-top: 0.7rem;
        margin-bottom: 0;
    }
</style>